const initialState = {
    billsData: {
      hbBills: [],
      sbBills: [],
      sjrBills: [],
      hjrBills: [],
    },
    loading: false,
    error: null,
  };
  
  const billsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'FETCH_BILLS_REQUEST':
        return { ...state, loading: true, error: null };
      case 'FETCH_BILLS_SUCCESS':
        return { ...state, loading: false, billsData: action.payload };
      case 'FETCH_BILLS_FAILURE':
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default billsReducer;